export default class RichText {
	constructor() {

		this.editorImages = document.querySelectorAll('.rich-text img');
		this.editorImages.forEach((img) => {
			let link = img.closest('a');
			if (link && link.getAttribute('target') !== "_blank") {
				link.classList.add('image-pswp');
				link.setAttribute('data-pswp-src', img.src);
				link.setAttribute('data-pswp-width', img.getAttribute('width'));
				link.setAttribute('data-pswp-height', img.getAttribute('height'));
				link.setAttribute('data-pswp-alt', img.getAttribute('alt'));
			}
		});

		this.editorLists = document.querySelectorAll('.rich-text ul.list-large li');
		this.editorLists.forEach((list) => {
			list.innerHTML = `<span class="text">${list.innerHTML}</span>`;
			const element = document.createElement("span");
			element.innerHTML = `<svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.08382 13.663C6.87659 13.8909 6.61098 14 6.34866 14C6.08695 13.9999 5.81952 13.8886 5.61441 13.663L0.31262 7.83302C-0.104193 7.37461 -0.10422 6.62473 0.31262 6.16634C0.720446 5.71799 1.37425 5.71792 1.78203 6.16634L6.34866 11.1895L16.218 0.336355C16.6258 -0.112118 17.2796 -0.112118 17.6874 0.336355C18.1042 0.794767 18.1042 1.54465 17.6874 2.00303L7.08382 13.663Z" fill="white"/>
</svg>`;
			element.classList.add('svg');
			list.prepend(element);
		});

	}
}
